"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ConnectorCommando = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 30 30", testID: "connectorIcon-Commando" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "evenodd", d: "M17.68,20.43a3,3,0,1,0-3,2.94A3,3,0,0,0,17.68,20.43ZM20.39,6.36a3,3,0,0,1,3,2.94,3,3,0,0,1-6.06,0A3,3,0,0,1,20.39,6.36ZM12.25,9.3a3,3,0,0,0-6.06,0,3,3,0,0,0,6.06,0ZM14.64-.13A14,14,0,0,1,28.85,13.63,13.85,13.85,0,0,1,18.7,26.82a.93.93,0,0,0-.7.9v1.19a1,1,0,0,1-.95.95H12.56a1,1,0,0,1-1-.95v-1.1a.94.94,0,0,0-.72-.91A13.86,13.86,0,0,1,.44,13.63,14,14,0,0,1,14.64-.13Z" })));
};
ConnectorCommando.defaultProps = {
    color: 'currentColor',
    width: 30,
    height: 30,
};
exports.default = react_1.default.memo(ConnectorCommando);
